import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';

export default {
    namespace: 'keycloakApi',

    state: {
        users: null,
    },

    effects: (dispatch: any) => ({
        fetchUsers() {
            return actionWrapper(
                 () => axios.get('keycloak/users/')
                     .then((res) => {
                         dispatch.keycloakApi.fetchUsers_reducer(res?.data);
                         return res;
                     }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
    }),

    reducers: {
        fetchUsers_reducer(state: any, payload: any) {
            return {...state, users: payload};
        },
    },
};
